import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';
import withRouter from '../withRouter';
import s from './style.module.less';
@inject('store')
@observer
class ToolTipMenu extends Component {
    onClick = (item, secondLevelMenu, firstLevelMenu) => {
        let toPath = '';
        const { global, menu } = this.props.store,
            { side_url } = global.platform;
        if (item.resource_source === 2) {
            //低代码
            toPath = `/${side_url}/tenant/view/${item.page_key}`;
        } else if (item.resource_source === 4 && item.new_tab === 1) {
            //外链
            window.open(item.resource_path);
            return false;
        } else {
            toPath = `/${side_url}/${item.resource_path}`;
        }
        menu.setMenuState({
            outSelectMenu: firstLevelMenu,
            subSelectMenu: item,
            subMenuOpenKeys: [secondLevelMenu.id]
        });
        // window.location.href = toPath;
        this.props.navigate(toPath);
    };

    render() {
        const { menu, curRouteInfo } = this.props;

        return (
            <div className={s['tool-tip-menu-wrap']}>
                {menu.children &&
                    menu.children.map((secondMenu, topIndex) => {
                        return (
                            <ul key={topIndex} style={s['group-ul']}>
                                <li className={s['title']}>{secondMenu.name || secondMenu.resource_name}</li>
                                {secondMenu.children &&
                                    secondMenu.children.map((ele, index) => {
                                        return (
                                            <li
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    this.onClick(ele, secondMenu, menu);
                                                }}
                                                className={s['content-menu']}
                                                key={index}
                                                style={{ color: curRouteInfo.id === ele.id ? '#8CB2FF' : 'white' }}
                                            >
                                                {ele.name || ele.resource_name}
                                            </li>
                                        );
                                    })}
                            </ul>
                        );
                    })}
            </div>
        );
    }
}

export default withRouter(ToolTipMenu);
